// react_frontend/src/App.js
import "./Assets/CSS/styles.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { RouterProvider } from "react-router-dom";
import ProjectRouter from "./Components/Router/ProjectRouter";
import PublicRouter from "./Components/Router/PublicRouter";
import React, { useContext, useEffect, useState } from "react";
import { MotherContext } from "./Context/MotherContext";
import { useAutoSync } from './hooks/useOfflineSync';

// ✅ Import Support Context Provider
import { SupportProvider } from "./Context/SupportContext";

function AppContent() {
  const { fetchProfile } = useContext(MotherContext);
  const [loading, setLoading] = useState(true);
  const [tokenValid, setTokenValid] = useState(false);
  const apiUrl = process.env.REACT_APP_API_BASE_URL + '/api';
  const token = localStorage.getItem("token");

  useAutoSync(apiUrl, token);

  useEffect(() => {
    if (!token) {
      setLoading(false);
      setTokenValid(false);
      return;
    }

    fetchProfile()
      .then(() => setTokenValid(true))
      .catch((err) => {
        console.error("Profile fetch failed:", err);
        localStorage.clear();
        setTokenValid(false);
      })
      .finally(() => setLoading(false));
  }, [fetchProfile, token]);

  if (loading) return <div>Loading...</div>;

  return <RouterProvider router={tokenValid ? ProjectRouter : PublicRouter} />;
}

// ✅ Wrap with SupportProvider — but DO NOT render SupportWidget here
function App() {
  return (
    <SupportProvider>
      <AppContent />
    </SupportProvider>
  );
}

export default App;